import brand, { BrandColours } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import UspCardStyles from '@stories/Components/Cards/UspCard/UspCard.styles';
import ControlsStyles from '@stories/Components/Misc/Carousels/Carousel/Controls/Controls.styles';
import MotionTrackStyles from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack.styles';
import FullWidthCarouselStyles from '@stories/Components/Misc/Carousels/FullWidthCarousel/FullWidthCarousel.styles';
import HeadingSummaryBlockStyles from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Outer = styled.div `
  scroll-margin: var(--headerHeight, 0px) 0 0;
  overflow: hidden;
  --fgColour: ${brand.primary.blue.dark};
  --widgetBgColour: transparent;
  --widgetNumberColour: ${brand.global.white};

  background-color: var(--widgetBgColour);

  &[data-variant=${BrandColours.BlueDark}],
  &[data-variant=${BrandColours.PurpleLight}],
  &[data-variant=${BrandColours.PurpleDark}] {
    --fgColour: ${brand.global.white};
    --widgetNumberColour: var(--widgetBgColour);
  }

  &[data-variant=${BrandColours.BlueDark}] {
    --widgetFgColour: ${brand.global.white};
    --widgetBgColour: ${brand.primary.blue.dark};

    ${ControlsStyles.Button} {
      box-shadow: none;
    }
  }

  &[data-variant=${BrandColours.PurpleLight}] {
    --widgetFgColour: ${brand.global.white};
    --widgetBgColour: ${brand.primary.purple.light};

    ${ControlsStyles.Button} {
      box-shadow: none;
    }
  }

  &[data-variant=${BrandColours.PurpleDark}] {
    --widgetFgColour: ${brand.global.white};
    --widgetBgColour: ${brand.primary.purple.dark};

    ${ControlsStyles.Button} {
      box-shadow: none;
    }
  }

  &[data-variant=${BrandColours.White}] {
    --widgetFgColour: ${brand.primary.blue.dark};
    --widgetBgColour: transparent;
  }

  ${HeadingSummaryBlockStyles.Container} {
    margin-bottom: ${fluid(40, 76)};
    color: var(--fgColour);
  }

  ${FullWidthCarouselStyles.Container} {
    --bgColour: var(--widgetBgColour);
    --fgColour: var(--widgetFgColour);

    ${SectionWrapperStyles.Inner} {
      padding-bottom: ${fluid(32, 48)};
    }
  }

  ${FullWidthCarouselStyles.CarouselWrapper} {
    @media ${from(Device.Desktop)} {
      overflow: hidden;
    }
  }

  ${FullWidthCarouselStyles.CarouselWrapper} {
    --visibleItems: 1;

    @media ${from(Device.Tablet)} {
      --visibleItems: 2;
    }

    @media ${from(Device.TabletLarge)} {
      --visibleItems: 3;
    }

    @media ${from(Device.Desktop)} {
      --visibleItems: 4;
    }
  }

  &[data-column-layout='5'] {
    ${FullWidthCarouselStyles.CarouselWrapper} {
      @media ${from(Device.Desktop)} {
        --visibleItems: 5;
      }
    }
  }

  &[data-is-grid='false'] {
    padding-bottom: ${fluid(36, 80)};
    ${SectionWrapperStyles.Inner} {
      padding-bottom: 0;
    }
  }

  @media print {
    page-break-before: auto;
    page-break-after: auto;
    page-break-inside: avoid;

    ${MotionTrackStyles.Track} {
      flex-wrap: wrap;
      gap: 16px;
    }

    ${FullWidthCarouselStyles.Item} {
      flex: 1 0 40%;
      border: 1px solid ${brand.global.black};
      border-radius: 10px;
      padding: 16px;
    }

    ${UspCardStyles.ImageContainer} {
      display: none;
    }

    ${UspCardStyles.ContentArea} {
      color: ${brand.global.black};
    }
  }
`;
const Container = styled(SectionWrapper) `
  overflow: hidden;

  --sectionBackground: transparent;
  --sectionColour: var(--widgetFgColour);

  ${HeadingSummaryBlockStyles.Container} {
    margin-bottom: ${fluid(16, 58)};

    [data-is-numbered='true'] & {
      @media ${until(Device.Tablet)} {
        text-align: center;
      }
    }
  }
`;
const Grid = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${fluid(24, 140)} ${fluid(24, 32)};

  --visibleItems: 2;

  [data-is-numbered='true'] & {
    @media ${until(Device.Tablet)} {
      --visibleItems: 1;
    }
  }

  @media print {
    --visibleItems: 2;
  }

  ${UspCardStyles.Container} {
    flex: 0 0 calc((100% - (${fluid(24, 32)} * (var(--visibleItems) - 1))) / var(--visibleItems));
  }

  @media ${from(Device.Tablet)} {
    --visibleItems: 2;
  }

  @media ${from(Device.TabletLarge)} {
    --visibleItems: 3;
  }

  @media ${from(Device.Desktop)} {
    --visibleItems: 4;

    [data-column-layout='5'] & {
      --visibleItems: 5;
    }
  }

  [data-card-alignment='center'] & {
    @media ${from(Device.TabletLarge)} {
      justify-content: center;
    }
  }
`;
const Base = styled.div `
  margin-top: ${fluid(36, 80)};
  padding-left: var(--sitePadding);
  padding-right: var(--sitePadding);

  @media ${from(Device.Tablet)} {
    text-align: center;
  }
`;
const UspStyles = {
    Base,
    Container,
    Grid,
    Outer,
};
export default UspStyles;
